<ul class="list-unstyled">
  <h4 class="title">{{ tour.name }}</h4>
  <li *ngFor="let article of tour.articles" class="item">
    <a
      *ngIf="article.id !== this.idArticle"
      class="link"
      tabindex="0"
      (click)="redirectArticle(article.resumo)"
      (keydown.enter)="redirectArticle(article.resumo)"
      (keydown.space)="redirectArticle(article.resumo)"
      >{{ article.titulo }}</a
    >
    <a *ngIf="article.id === this.idArticle" class="link-tour">{{
      article.titulo
    }}</a>
  </li>
</ul>
